<template>
  <div class="table-node__container">
    <div class="table-node__header">
      <span
        class="table-node__title"
        :id="`table-${value.uuid}`"
        v-if="value.meta && value.meta.caption"
        v-html="value.meta.caption"
      />
      <div class="table-node__options">
        <button class="table-node__options-btn" @click="toggleIsVisible">
          {{ isVisible ? 'hide' : 'show' }} table
        </button>
      </div>
    </div>

    <table class="table-node" :aria-labelledby="`table-${value.uuid}`" v-show="isVisible">
      <thead class="table-node__header-row">
        <tr>
          <th
            scope="column"
            v-for="columnName in data.columnNames"
            :key="columnName"
            class="table-node__heading-cell"
          >
            {{ columnName }}
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(row, idx) in data.data">
          <tr
            v-if="row && row.filter((el) => Array.isArray(el)).length === 0"
            :key="idx"
            class="table-node__row"
          >
            <th scope="row" class="table-node__heading-cell">{{ data.rowNames[idx] }}</th>
            <Cell
              v-for="(cellData, cellIdx) in row"
              :key="cellIdx"
              :data="cellData"
              class="table-node__cell"
            />
          </tr>

          <tr
            v-else
            v-for="(groupedRow, groupIdx) in row"
            :key="'group-' + groupIdx"
            class="table-node__row"
          >
            <th
              v-if="groupIdx === 0"
              :rowspan="row.length"
              scope="row"
              class="table-node__heading-cell"
            >
              {{ data.rowNames[idx] }}
            </th>
            <Cell
              v-for="(cellData, cellIdx) in groupedRow"
              :key="cellIdx"
              :data="cellData"
              class="table-node__cell"
            />
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';
import Cell from './Cell';

export default {
  name: 'DisplayTable',
  components: { Cell },
  props: {
    value: PigeonDocNodeModel,
  },
  computed: {
    data() {
      return this.value.content.data;
    },
    isVisible() {
      // state is not defined or its set to "visible" or "hidden"
      return !this.value.meta || !this.value.meta.state || this.value.meta.state === 'visible';
    },
  },
  methods: {
    toggleIsVisible() {
      const state = this.isVisible ? 'hidden' : 'visible';

      const updated = {
        ...this.value,
        meta: {
          ...this.value.meta,
          state,
        },
      };

      this.$emit('updateNode', updated);
    },
  },
};
</script>

<style>
.table-node {
  border-collapse: collapse;
  max-width: 100ch;
  overflow: auto;
  display: block;
}

.table-node__container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 4rem 0;
}

.table-node__header {
  display: flex;
  align-items: center;
  flex: 100%;
  padding: 0.5rem;
}

.table-node__title {
  display: block;
  font-weight: bold;
}

.table-node__options {
  margin-left: auto;
}

.table-node__heading-cell {
  padding: 0.5rem;
  border: 1px solid #959595;
}

.table-node__heading-cell:first-child {
  border-left: none;
}

.table-node__heading-cell:last-child {
  border-right: none;
}

.table-node__header-row .table-node__heading-cell {
  border-top: none;
}

.table-node__row:last-child .table-node__heading-cell {
  border-bottom: none;
}

.table-node__cell {
  padding: 0.5rem;
  border: 1px solid #959595;
}

.table-node__cell:last-child {
  border-right: none;
}

.table-node__row:last-child .table-node__cell {
  border-bottom: none;
}
</style>
